"use client";

import * as React from "react";
import { motion } from "framer-motion";
import { Share2, ShieldCheck, Clock, CircleCheck as CheckCircle2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
const protectionData = [{
  id: "sharing",
  title: "Sharing Your Information",
  icon: Share2,
  description: "We may share your information with:",
  items: ["Suppliers and manufacturers involved in providing products or warranty support", "Subcontractors working on our behalf", "Accountants, legal advisers, and professional consultants", "Payment processors", "Regulatory authorities where required by law"],
  footer: "We will never sell your personal information to third parties."
}, {
  id: "security",
  title: "Data Security",
  icon: ShieldCheck,
  description: "We take appropriate technical and organisational measures to protect your personal information against unauthorised access, loss, misuse, alteration, or disclosure.",
  items: [],
  footer: ""
}, {
  id: "retention",
  title: "Data Retention",
  icon: Clock,
  description: "We retain personal information only for as long as necessary to:",
  items: ["Fulfil the purposes for which it was collected", "Comply with legal, accounting, and tax obligations", "Resolve disputes and enforce agreements"],
  footer: "Records relating to completed works may be retained for up to 7 years or longer where required by law."
}];
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};
export default function DataProtectionDetails() {
  return <section id="dataprotectiondetails" className="bg-background py-16 md:py-24">
      <div className="container mx-auto max-w-4xl px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="font-default text-primary mb-4 text-3xl font-bold tracking-tight md:text-4xl">
            Data Protection & Privacy
          </h2>
          <p className="text-muted-foreground font-sans mx-auto max-w-2xl text-lg">
            How we handle, secure, and retain your personal information in accordance with UK data protection laws.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.2
      }} className="flex flex-col gap-8">
          {protectionData.map((section, i) => {
          const Icon = section.icon;
          return <motion.div key={section.id} variants={itemVariants} data-index={i}>
                <Card className="overflow-hidden border-none shadow-md">
                  <CardHeader className="bg-muted/50 border-b pb-6">
                    <div className="flex items-center gap-4">
                      <div className="bg-primary/10 text-primary flex size-12 shrink-0 items-center justify-center rounded-lg">
                        <Icon className="size-6" />
                      </div>
                      <CardTitle className="font-default text-primary text-2xl">
                        {section.title}
                      </CardTitle>
                    </div>
                  </CardHeader>
                  <CardContent className="font-sans pt-6">
                    <p className="text-foreground mb-4 text-base leading-relaxed">
                      {section.description}
                    </p>

                    {section.items.length > 0 && <ul className="mb-6 space-y-3">
                        {section.items.map((item, itemIndex) => <li key={itemIndex} data-index={itemIndex} className="text-muted-foreground flex items-start gap-3 text-base">
                            <CheckCircle2 className="text-primary mt-0.5 size-5 shrink-0" />
                            <span>{item}</span>
                          </li>)}
                      </ul>}

                    {section.footer && <>
                        {section.items.length > 0 && <Separator className="my-6" />}
                        <p className="text-foreground font-medium">
                          {section.footer}
                        </p>
                      </>}
                  </CardContent>
                </Card>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}